import { createAction, props } from '@ngrx/store';
import {SpesenartItem} from '../../spesenart.model';

export const deactivateSpesenartStart = createAction('ZEIT::DEACTIVATE_SPESENART_START', props<{ item: SpesenartItem}>());
export const deactivateSpesenartSucceeded = createAction('ZEIT::DEACTIVATE_SPESENART_SUCCEEDED', props<{ item: SpesenartItem }>(), );
export const deactivateSpesenartFailed = createAction('ZEIT::DEACTIVATE _SPESENART_FAILED', props<{ error: Error }>());
